import { BottinaButton } from '@components/components';
import React from 'react';

const CmsBottina = () => {
  const handleChatClick = () => {
    if (window.OnlimCw) {
      window.OnlimCw('open');
    }
  };

  return <BottinaButton onClick={handleChatClick} />;
};

export default CmsBottina;
